import { config } from "@repo/config";
import { SessionProvider } from "@saas/auth/client";
import { ActiveOrganizationProvider } from "@saas/organizations/client";
import { ConfirmationAlertProvider } from "@saas/shared/client";
import { reuseWhileStaying } from "@shared/lib/route-context-cache";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { getOrganizationListFn, getSessionFn } from "~/server/auth";

export const Route = createFileRoute("/_saas")({
	beforeLoad: async ({ location, cause }) => {
		// Fetch session and org list in parallel to reduce waterfall
		const [session, organizations] = await Promise.all([
			reuseWhileStaying("session", cause, () => getSessionFn()),
			config.organizations.enable
				? reuseWhileStaying("organizations", cause, () =>
						getOrganizationListFn(),
					)
				: Promise.resolve([]),
		]);

		if (!session?.user) {
			// Carry the destination through login. LoginForm and OtpForm already
			// read `redirectTo`; without sending it here that was only ever half
			// wired, so any deep link into /app hit while logged out (an email
			// notification, a bookmark, an expired session) dropped the user on
			// the dashboard instead of where they were going.
			throw redirect({
				to: "/login",
				search: { redirectTo: location.href },
			});
		}

		return { session, organizations };
	},
	component: SaaSLayout,
});

function SaaSLayout() {
	const { session } = Route.useRouteContext();

	return (
		<SessionProvider initialSession={session}>
			<ActiveOrganizationProvider>
				<ConfirmationAlertProvider>
					<Outlet />
				</ConfirmationAlertProvider>
			</ActiveOrganizationProvider>
		</SessionProvider>
	);
}
